// Library Imports
import React from 'react'
import { Form } from 'react-bootstrap'
import * as BiIcons from 'react-icons/bi'
// Asset Imports
import '../../assets/css/stylesheets/components/search/NameSearch.css'

function NameSearch({ textValue, onTextChanged }) {
    return (
        <>
            <div className='namesearch'>
                <BiIcons.BiSearchAlt className='namesearch-icon' />
                <Form.Control
                    className='namesearch-control'
                    id='nameSearchText'
                    type='text'
                    placeholder='What are you looking for?' 
                    value={textValue} 
                    onChange={onTextChanged} />
            </div>
        </>
    )
}

export default NameSearch